<template>
    <div class="div"></div>
</template>

<style lang="scss" scoped>
.div {
    width: 50%;
    //padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    background-color: rgba(0, 0, 0, 0.12);
    cursor: wait;
    height: 30px;
    margin-bottom: 0.25rem;
    border-radius: 0.25rem;
}
</style>
